import type { VfConfig } from '#types/config/components/vf'

export default {
  brandClasses: {
    controlsInactive: '!op-0'
  },
  controlsSize: 'md'
} satisfies VfConfig['carousel']
